import React, { useMemo, useEffect } from 'react';
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
  useAsyncDebounce,
} from 'react-table';

import BaseTable from '../../../shared/BaseTable';
import Loading from '../../../shared/Loading';
import { TableColumns } from './TableColumns';

export default function OrdersTable({
  orders,
  ordersLoading,
  totalRows,
  pageCount,
  fetchData,
}) {
  const data = useMemo(() => orders, [orders?.length]);
  const columns = useMemo(() => TableColumns, []);
  const instance = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 25,
        sortBy: [{ id: 'disbursement_date', desc: true }],
      },
      manualSortBy: true,
      disableSortBy: true,
      manualPagination: true,
      autoResetPage: false,
      pageCount: pageCount,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const { pageIndex } = instance.state;

  const onFetchDataDebounced = useAsyncDebounce(fetchData, 250);

  // If provided with a data fetching function for any server side pagination / filtering etc,
  // listen for related changes and load new page data.
  useEffect(() => {
    if (!fetchData) return;

    onFetchDataDebounced({ pageIndex });
  }, [pageIndex]);

  if (!orders || ordersLoading) return <Loading className="w-14 h-14" />;

  return (
    <div
      role={OrdersTable.role}
      className="col-span-full rounded-lg border border-black border-opacity-5 py-1 overflow-x-scroll mt-6"
    >
      <BaseTable
        tableInstance={instance}
        noDataFoundWarning="No Orders Found."
        totalRows={totalRows}
      />
    </div>
  );
}

OrdersTable.role = 'orders-table-component';
